import React from "react";
import icon1 from "../assest/icon5.jpg";
import icon2 from "../assest/icon2.png";
import icon3 from "../assest/icon3.png";
import icon4 from "../assest/icon4.png";

export default function TrainingInfoBar() {
  const infoItems = [
    { icon: icon1, text: "Learn The Essential Skills" },
    { icon: icon2, text: "Earn Certificates And Degrees" },
    { icon: icon3, text: "Get Ready For The Next Career" },
    { icon: icon4, text: "Master at Different Areas" },
  ];

  return (
    <section className="bg-white py-6 md:py-10 border-y-2 border-red-600 shadow-sm relative z-10" aria-label="Training Benefits">
      {/* Grid Settings:
          - grid-cols-2 (Mobile par 2 items ek line mein, taaki screen bhari lage)
          - lg:grid-cols-4 (Desktop par 4 items)
      */}
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-4 md:gap-6 px-4 md:px-8">
        {infoItems.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center gap-2 md:gap-3 group cursor-default"
          >
            {/* Icon Container with responsive sizing */}
            <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-red-50 rounded-full transition-all duration-300 group-hover:bg-red-100 group-hover:scale-110 shadow-sm">
              <img
                src={item.icon}
                alt={`${item.text} Icon Feature`}
                loading="lazy"
                className="w-10 h-10 md:w-12 md:h-12 object-contain transition-all duration-300"
                // Aapka filter color perfect hai, ise barkarar rakha hai
                style={{ filter: 'invert(29%) sepia(93%) saturate(6336%) hue-rotate(350deg) brightness(93%) contrast(105%)' }}
              />
            </div>

            {/* Responsive Text sizing */}
            <span className="text-xs sm:text-sm md:text-base font-bold text-gray-800 px-2 leading-tight md:leading-normal">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}